"use client"

import { useState } from 'react'
import { Menu, X } from 'lucide-react'
import { useMediaQuery } from '@/lumora/hooks/useMediaQuery'

const NAV_LINKS = [
  { label: 'Features',     href: '#features'     },
  { label: 'Workflow',     href: '#workflow'      },
  { label: 'Testimonials', href: '#testimonials'  },
  { label: 'FAQs',         href: '#faqs'          },
]

const MOBILE_QUERY = '(max-width: 640px)'

export default function Navbar() {
  const isMobile = useMediaQuery(MOBILE_QUERY)
  const [open, setOpen] = useState(false)

  if (isMobile) {
    return (
      <>
        <button
          onClick={() => setOpen((o) => !o)}
          aria-label={open ? 'Close menu' : 'Open menu'}
          style={{
            position: 'absolute',
            top: 20,
            right: 20,
            zIndex: 51,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 40,
            height: 40,
            borderRadius: '50%',
            background: 'rgba(10,8,16,0.6)',
            border: '1px solid rgba(124,58,237,0.45)',
            color: '#e2d9f3',
            backdropFilter: 'blur(12px)',
            cursor: 'pointer',
          }}
        >
          {open ? <X size={19} /> : <Menu size={19} />}
        </button>

        {open && (
          <div style={{
            position: 'absolute',
            top: 68,
            right: 20,
            zIndex: 50,
            display: 'flex',
            flexDirection: 'column',
            minWidth: 180,
            background: 'rgba(13,11,20,0.96)',
            border: '1px solid rgba(124,58,237,0.35)',
            borderRadius: 14,
            padding: 6,
            backdropFilter: 'blur(16px)',
            boxShadow: '0 20px 50px rgba(0,0,0,0.5)',
          }}>
            {NAV_LINKS.map(({ label, href }) => (
              <a
                key={href}
                href={href}
                onClick={() => setOpen(false)}
                style={{
                  padding: '11px 16px',
                  borderRadius: 9,
                  color: '#e2d9f3',
                  fontSize: 'var(--font-md)',
                  fontWeight: 500,
                  textDecoration: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                {label}
              </a>
            ))}
          </div>
        )}
      </>
    )
  }

  return (
    <div
      className="lumora-navbar"
      style={{
        position: 'absolute',
        top: 28,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 50,
        display: 'flex',
        gap: 4,
        alignItems: 'center',
        background: 'rgba(10,8,16,0.5)',
        border: '1px solid rgba(124,58,237,0.45)',
        borderRadius: 999,
        padding: '6px 10px',
        backdropFilter: 'blur(12px)',
      }}
    >
      <style>{`
        @media (max-width: 900px) {
          .lumora-navbar a { padding: 7px 12px !important; font-size: 12px !important; }
        }
      `}</style>
      {NAV_LINKS.map(({ label, href }) => (
        <a
          key={href}
          href={href}
          style={{
            padding: '7px 20px',
            background: 'transparent',
            border: 'none',
            borderRadius: 999,
            color: '#e2d9f3',
            fontSize: 'var(--font-base)',
            fontWeight: 500,
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            letterSpacing: '0.01em',
            textDecoration: 'none',
            display: 'block',
            transition: 'background 0.15s, color 0.15s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'rgba(124,58,237,0.15)'
            e.currentTarget.style.color = '#C4B5FD'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'transparent'
            e.currentTarget.style.color = '#e2d9f3'
          }}
        >
          {label}
        </a>
      ))}
    </div>
  )
}
